import { Controller } from "@hotwired/stimulus"
import SlimSelect from "slim-select"
import { slimSelectSettings } from "../helpers/slim_select_helpers"

export default class extends Controller {
  static values = {
    siteId: { type: Number, default: 0 },
    canCreate: { type: Boolean, default: false },
    searchOrCreatePlaceholder: { type: String, default: "Suchen oder neu erstellen" },
    searchPlaceholder: { type: String, default: "Suchen" },
    selectPlaceholder: { type: String, default: "Auswählen" },
    addableText: { type: String, default: '"{value}" erstellen (Enter drücken)' },
  }

  connect() {
    this.initSlimSelect()
  }

  disconnect() {
    if (this.slimSelect) {
      this.slimSelect.destroy()
    }
  }

  reinitialize() {
    if (this.slimSelect) {
      this.slimSelect.destroy()
    }
    this.initSlimSelect()
  }

  initSlimSelect() {
    const addable = this.canCreateValue && this.siteIdValue > 0

    const config = {
      select: this.element,
      settings: slimSelectSettings({
        allowDeselect: true,
        showSearch: true,
        searchPlaceholder: addable
          ? this.searchOrCreatePlaceholderValue
          : this.searchPlaceholderValue,
        placeholderText: this.element.dataset.placeholder || this.selectPlaceholderValue,
        closeOnSelect: !this.element.getAttribute("multiple"),
      }),
      events: {
        searchFilter: (option, search) => {
          if (search.length === 0) return true
          const searchTerms = search.toLowerCase().split(" ")
          const optionText = option.text.toLowerCase()
          return searchTerms.every((term) => optionText.includes(term))
        },
      },
    }

    if (addable) {
      config.settings.addableText = this.addableTextValue
      config.events.addable = (value) => {
        return this.createTask(value)
      }
    }

    this.slimSelect = new SlimSelect(config)
  }

  async createTask(name) {
    const trimmedName = name.trim()
    if (trimmedName.length === 0) return false

    const siteId = this.siteIdValue
    if (!siteId || siteId === 0) return false

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    try {
      const response = await fetch(`/sites/${siteId}/create_site_task`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-CSRF-Token": csrfToken,
        },
        body: JSON.stringify({ name: trimmedName }),
      })

      if (!response.ok) return false

      const data = await response.json()
      return { text: data.name, value: String(data.id) }
    } catch (error) {
      console.error("Task creation failed:", error)
      return false
    }
  }
}
